/*
 * Copyright (c) 2022-2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {OAuthResourceServerErrorHandler, OAuthStorage} from 'angular-oauth2-oidc';
import {environment} from '../../../environments/environment';

import {Observable} from 'rxjs';

/***
 * Created by Ryan Pham
 */

/** Inject With Credentials into the request */
@Injectable()
export class HttpInterceptors implements HttpInterceptor {

  constructor(private authStorage: OAuthStorage, private errorHandler: OAuthResourceServerErrorHandler) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const token = this.authStorage.getItem('access_token');

    // Check for a token to fill in, and  ensure that the url we're rewriting is one
    // for our API so that we don't send our token to just any site.
    if (token && req.url.startsWith(environment.apiUrl)) {

      const tokenHeader = 'Bearer ' + token;

      // intercept and add with credentials to request and headers
      req = req.clone({
        headers: req.headers.append('Authorization', tokenHeader)
      });

      return next.handle(req);

    } else {
      return next.handle(req);
    }
    // TODO: catch isn't a function.
    // return next.handle(req).catch(err => this.errorHandler.handleError(err));
  }
}
